<script setup lang="ts">
import { computed } from "vue";

import PhotoThumb from "@/components/PhotoThumb.vue";

const props = withDefaults(
  defineProps<{ fileIds: string[]; title?: string }>(),
  { title: "Photos" },
);

const ids = computed(() => props.fileIds ?? []);
</script>

<template>
  <section
    v-if="ids.length"
    class="rounded-xl border border-neutral-200 bg-neutral-0 p-6"
  >
    <h2 class="mb-3 font-semibold">
      {{ title }} ({{ ids.length }})
    </h2>
    <div class="grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-6">
      <PhotoThumb
        v-for="id in ids"
        :key="id"
        :file-id="id"
      />
    </div>
  </section>
</template>
